export const KNOWN_PLUGIN_NAMES = {
    PATENT: 'patent',
    PAPER: 'paper',
    MARKET: 'market',
    INVESTMENT: 'investment',
    MERGER: 'merger',
    BIO: 'bio',
    DRUG: 'drug',
    CLINICAL: 'clinical',
    CLINICAL_RESULT: 'clinical_result',
};
export const PLUGIN_NAME_TO_DATATYPE_MAP = {
    [KNOWN_PLUGIN_NAMES.PATENT]: 'PATENT',
    [KNOWN_PLUGIN_NAMES.PAPER]: 'PAPER',
    [KNOWN_PLUGIN_NAMES.MARKET]: 'MR',
    [KNOWN_PLUGIN_NAMES.INVESTMENT]: 'VC',
    [KNOWN_PLUGIN_NAMES.MERGER]: 'MA',
    [KNOWN_PLUGIN_NAMES.BIO]: 'BIO',
    [KNOWN_PLUGIN_NAMES.DRUG]: 'DRUG',
    [KNOWN_PLUGIN_NAMES.CLINICAL]: 'CLINICAL',
    [KNOWN_PLUGIN_NAMES.CLINICAL_RESULT]: 'CLINICAL_RESULT',
};
// revert simple object key value
function revertObject(obj) {
    const revertedObj = {};
    Object.keys(obj).forEach(key => {
        revertedObj[obj[key]] = key;
    });
    return revertedObj;
}
export const KNOWN_DATATYPE_TO_NAME_MAP = revertObject(PLUGIN_NAME_TO_DATATYPE_MAP);
export function getPluginNameByDataType(dataType) {
    if (!KNOWN_DATATYPE_TO_NAME_MAP[dataType]) {
        console.error('Unknown datatype:', dataType);
    }
    return KNOWN_DATATYPE_TO_NAME_MAP[dataType] || dataType;
}
